/* eslint-disable object-curly-spacing */
/* eslint-disable no-plusplus */
/* eslint-disable react/prop-types */
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import {
  Text,
  Table,
  Button,
  Icon,
} from 'components/atoms';
import { Tooltip } from 'components/molecules'
import { injectIntl } from 'react-intl'
import { intlType } from 'types'
import { Link } from 'react-router-dom'

const PeopleTable = memo(({
  data,
  loading,
  intl,
  noDataText,
  subweb,
  activeRowId,
  isPeopleModule,
  onClickAdd,
  setCheck,
  refetchData
}) => {
  const handlePeopleSelect = (data, id, disabledCheck) => {
    let val = null;
    // eslint-disable-next-line no-plusplus
    if (!disabledCheck) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].id === id) {
          refetchData()
          if (data[i].check === true) {
            setCheck(i, data[i].photoId, false)
          }
          else {
            setCheck(i, data[i].photoId, true)
          }
          
          val = data[i];
        } 
      }
      if (val !== null) {
        if (val.check === true) {
          val.check = false;
        }
        else {
          val.check = true
        }
        onClickAdd(val)
      }
    }
  }

  return (
    <Table
      data={data}
      columns={[
        {
          Header: '',
          accessor: 'icon',
          width: 50,
          Cell: ({original: { id, check, disabledCheck } }) => ( 
            isPeopleModule ? [
              <Tooltip tooltip="selecionar pessoa" placement="top">
                <CellStart>
                  <Button modifiers={disabledCheck ? ['small', 'primaryHover', 'disabled'] : ['small', 'primaryHover']} onClick={(e) => handlePeopleSelect(data, id, disabledCheck)}>
                    <Icon icon={check ? 'fal fa-check' : 'fal fa-plus'} height={16} />
                  </Button>
                </CellStart>
              </Tooltip>
            ] 
              : []
          ),
        },
        {
          Header: intl.formatMessage({ id: 'name' }),
          accessor: 'name',
          Cell: ({ value, original: { id, disabledCheck } }) => ( 
            !isPeopleModule ? [
              <Table.CellLink to={`/${subweb}/people/${id}`}>
                <Table.Cell
                  value={value}
                  loadingDots={loading}
                  modifiers={[Number(activeRowId) === id ? 'base' : '']}
                />
              </Table.CellLink>
            ] 
              : [
                disabledCheck ? [
                  <CellCursor>
                    {value} 
                  </CellCursor>
                ] : [
                  <Table.CellLink>
                    <Table.Cell
                      value={value}
                      loadingDots={loading}
                      modifiers={[Number(activeRowId) === id ? 'base' : '']}
                    />
                  </Table.CellLink>
                ]
                
              ]
          ),
        },
        {
          Header: intl.formatMessage({ id: 'category' }),
          accessor: 'category',
          Cell: ({ value, original: { id, disabledCheck } }) => (
            !isPeopleModule ? [
              <Table.CellLink to={`/${subweb}/people/${id}`}>
                <Table.Cell
                  value={value}
                  loading={loading}
                  modifiers={[Number(activeRowId) === id ? 'base' : '']}
                />
              </Table.CellLink>
            ] 
              : [
                disabledCheck ? [
                  <CellCursor>
                    {value} 
                  </CellCursor>
                ] : [
                  <Table.CellLink>
                    <Table.Cell
                      value={value}
                      loading={loading}
                      modifiers={[Number(activeRowId) === id ? 'base' : '']}
                    />
                  </Table.CellLink>
                ]
                
              ]
          ),
        },
        ...(
          !isPeopleModule ? [{
            Header: intl.formatMessage({ id: 'phoneExtension' }),
            accessor: 'phoneExtension',
            Cell: ({ value, original: { id } }) => (
              <Table.CellLink to={`/${subweb}/people/${id}`}>
                <Table.Cell
                  value={value}
                  loading={loading}
                  modifiers={[Number(activeRowId) === id ? 'base' : '']}
                />
              </Table.CellLink>
            ),
          }] : []
        ),
        {
          Header: intl.formatMessage({ id: 'email' }),
          accessor: 'email',
          Cell: ({ value, original: { id, disabledCheck } }) => (
            !isPeopleModule ? [
              <Table.CellLink
                as="a"
                href={`mailto:${value}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Table.Cell loading={loading}>
                  <Text
                    modifiers={['light', 'underline', Number(activeRowId) === id ? 'base' : '']}
                  >
                    {value}
                  </Text>
                </Table.Cell>
              </Table.CellLink>
            ] 
              : [
                disabledCheck ? [
                  <CellCursor>
                    <Text
                      modifiers={['light', 'underline', Number(activeRowId) === id ? 'base' : '']}
                    >
                      {value}
                    </Text> 
                  </CellCursor>
                ] : [
                  <Table.CellLink>
                    <Table.Cell loading={loading}>
                      <Text
                        modifiers={['light', 'underline', Number(activeRowId) === id ? 'base' : '']}
                      >
                        {value}
                      </Text>
                    </Table.Cell>
                  </Table.CellLink>
                ]
               
              ]
          ),
        },
        {
          Header: '',
          accessor: 'isVisible',
          resizable: false,
          width: 80,
          Cell: ({ value: isVisible, original: { id } }) => (
            !isPeopleModule ? [
              <Tooltip tooltip={`${isVisible ? '' : 'não'} visível no portal`} placement="top">
                <CellEnd to={`/${subweb}/people/${id}`}>
                  <Button modifiers={['small', 'invisible']}>
                    <Icon icon={`fal ${isVisible ? 'fa-eye' : 'fa-eye-slash'}`} height={16} />
                  </Button>
                </CellEnd>
              </Tooltip>
            ] 
              : [
                <Tooltip tooltip={`${isVisible ? '' : 'não'} visível no portal`} placement="top">
                  <CellEnd>
                    <Button modifiers={['small', 'invisible']}>
                      <Icon icon={`fal ${isVisible ? 'fa-eye' : 'fa-eye-slash'}`} height={16} />
                    </Button>
                  </CellEnd>
                </Tooltip>
              ]
          ),
        }
      ]}
      minRows={0}
      className="-striped -highlight"
      noDataText={loading ? '' : (noDataText || 'Não foram encontradas pessoas')}
      sortable={false}
      showPagination={false}
      loading={loading}
      loadingText="A carregar..."
      clearRowPadding
    />
  )
  
});

const CellStart = styled.div`
  width: 100%;
`

const CellEnd = styled(Link)`
  width: 100%;
  button {
    cursor: default;
  }
  text-decoration: none;
`

const CellCursor = styled(Link)`
  width: 100%;
  cursor: default;
  color: #484848;
  text-decoration: none;
  padding: 0.875rem 1.25rem;
`
PeopleTable.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      category: PropTypes.string.isRequired,
      phoneExtension: PropTypes.number.isRequired,
      email: PropTypes.string.isRequired,
      isVisible: PropTypes.bool.isRequired,
    })
  ),
  loading: PropTypes.bool,
  intl: intlType.isRequired,
  noDataText: PropTypes.string,
  subweb: PropTypes.string,
  activeRowId: PropTypes.string,
};

PeopleTable.defaultProps = {
  data: [],
  loading: true,
  noDataText: null,
  subweb: 'ua',
  activeRowId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}


export default injectIntl(PeopleTable);
